import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import BusinessPartnersBlockData from 'app/Models/Content/BusinessPartnersBlockData';
import React from 'react';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {Container} from 'reactstrap';
import useFadeIn from 'app/Components/Shared/UseFadeIn';

const BusinessPartnersBlock = ({data, context}: ComponentProps<BusinessPartnersBlockData>) => {
  const {ref, fadeClass} = useFadeIn();

  return (
    <div ref={ref} className={`BusinessPartnersBlock ${fadeClass}`}>
      <h2 className='BusinessPartnersBlock__title'>{data.title.value}</h2>
      <p className='BusinessPartnersBlock__subtitle'>{data.subtitle.value}</p>
      <Container>
        <div className='BusinessPartnersBlock__content'>
          <ContentArea noWrap data={data.items} context={context} />
        </div>
      </Container>
    </div>
  );
};

export default BusinessPartnersBlock;
